import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  HeaderComponent,
  PaginationComponent
} from "@comps/components";
import { makeRequest, makeRequestStateless } from "@utils/helpers";
import { Commons, Const } from "../constants";
import { Button, Card, Col, Row, Space, Tag, Typography, message } from 'antd';
import { FilterComponent, FilterButton } from "@comps/components";
import { deleteDataReq, getAllDataReq, getFilterReq } from "./requests";
import CreateRequestPolicyPlanner from "./components/CreateRequestPolicyPlanner";
import ViewRequestPolicyPlan from "./components/ViewRequestPolicyPlan";
import CreateDeductionType from "../settings/deductionTypes/components/CreateDeductionType";
import CreateEncashmentType from "../settings/encashmentTypes/components/CreateEncashmentType";
import CreateTravelPolicy from "../travelPolicy/components/CreateTravelPolicy";
import CreateAbsentPolicy from "../absentPolicy/components/CreateAbsentPolicy";
import CreateLateArrivalPolicy from "../lateArrivalPolicy/components/CreateLateArrivalPolicy";
import CreateEarlyLeftPolicy from "../earlyLeftPolicy/components/CreateEarlyLeftPolicy";
import CreateMissingPolicy from "../missingPolicy/components/CreateMissingPolicy";
import CreateShortDurationPolicy from "../shortDurationPolicy/components/CreateShortDurationPolicy";
import CreateRelaxationPolicy from "../relaxationPolicy/components/CreateRelaxationPolicy";
import CreateLeavePolicy from "../leavePolicy/components/CreateLeavePolicy";
import CreateCplPolicy from "../cplPolicy/components/CreateCplPolicy";
import CreateOvertimePolicy from "../overtimePolicy/components/CreateOvertimePolicy";
import { getAllDataReq as getTravelPolicyDataReq } from "../travelPolicy/requests";
import { getAllDataReq as getAbsentPolicyDataReq } from "../absentPolicy/requests";
import { getAllDataReq as getLateArrivalPolicyDataReq } from "../lateArrivalPolicy/requests";
import { getAllDataReq as getEarlyLeftPolicyDataReq } from "../earlyLeftPolicy/requests";
import { getAllDataReq as getMissingPolicyDataReq } from "../missingPolicy/requests";
import { getAllDataReq as getShortDurationPolicyDataReq } from "../shortDurationPolicy/requests";
import { getAllDataReq as getRelaxationPolicyDataReq } from "../relaxationPolicy/requests";
import { getAllDataReq as getLeavePolicyDataReq } from "../leavePolicy/requests";
import { getAllDataReq as getCplPolicyDataReq } from "../cplPolicy/requests";
import { getAllDataReq as getOvertimePolicyDataReq } from "../overtimePolicy/requests";
import moment from "moment";

const langKey = Const["requestPolicyPlanner"].lngKey;
const { Text } = Typography;

const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["requestPolicyPlanner"].route
      }
    ]
  }
}
//========================================
const IndexRequestPolicyPlanner = (props) => {
  const totalRecords = 0;
  const [allData, setAllData] = useState({});
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [filters, setFilters] = useState();
  //start pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });
  //end pagination states

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================

  const columns = [
    {
      key: 'code',
      title: trans(Commons.code),
      dataIndex: "code",
    },
    {
      key: 'name',
      title: trans(Commons.name),
      dataIndex: "name",
    },
    {
      key: 'date',
      title: trans(`${langKey}.date`),
      render: (record) => (
        moment(record.date).format('YYYY-MM-DD')
      ),
    },


    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onDelete={ onDelete }
          onView={ onView }
        ></ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [filters, currentPage]);

  const getAllData = () => {
    const payload = {
      page: currentPage,
      filters: filters
    }
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, null);
  };

  const onSuccess = (response) => {
    setAllData(response)
    setPagination(response.request_policy_planners);
    setDataSource(response.request_policy_planners.data);
  };

  const onEdit = (record) => {
    setChildComponent(
      // <UpdateAbsentPolicy onCompleted={ onCompleted } record={ record } allData={allData} disabled={ false } />
    );
  };

  const onView = (record) => {
    setChildComponent(
      <ViewRequestPolicyPlan onCompleted={ onCompleted } record={ record } allData={ allData } disabled={ true } />
    );
  };

  const onDelete = (record) => {
    makeRequest(setLoader, deleteDataReq, record.id, onDeleted, onError);
  };
  const onDeleted = (res) => {
    onSuccess(res)
    setDataSource(res.request_policy_planners.data);
    message.success("Record Deleted")
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  const onDependencyCompleted = (data) => {
    setChildComponent(null);

    if (data && data.length !== 0) {
      getAllData();
    }
  };

  const onDependencySuccess = () => {
    getAllData();
  };

  const openDependencyModal = (factory, requestFn) => {
    if (!requestFn) {
      setChildComponent(factory({}));
      return;
    }

    makeRequestStateless(requestFn, { page: 1, filters: filters }, (response) => {
      setChildComponent(factory(response));
    }, onError);
  };

  const onCreateDependency = (dependencyKey) => {
    const dependencyFactories = {
      deductionType: () => (
        <CreateDeductionType onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } />
      ),
      encashmentType: () => (
        <CreateEncashmentType onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } />
      ),
      travelPolicy: (response) => (
        <CreateTravelPolicy onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } allData={ response } />
      ),
      absentPolicy: (response) => (
        <CreateAbsentPolicy onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } allData={ response } />
      ),
      lateArrivalPolicy: (response) => (
        <CreateLateArrivalPolicy onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } allData={ response } />
      ),
      earlyLeftPolicy: (response) => (
        <CreateEarlyLeftPolicy onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } allData={ response } />
      ),
      missingPolicy: (response) => (
        <CreateMissingPolicy onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } allData={ response } />
      ),
      shortDurationPolicy: (response) => (
        <CreateShortDurationPolicy onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } allData={ response } />
      ),
      relaxationPolicy: (response) => (
        <CreateRelaxationPolicy onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } allData={ response } />
      ),
      leavePolicy: (response) => (
        <CreateLeavePolicy onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } allData={ response } />
      ),
      cplPolicy: (response) => (
        <CreateCplPolicy onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } allData={ response } />
      ),
      overtimePolicy: (response) => (
        <CreateOvertimePolicy onCompleted={ onDependencyCompleted } onSuccess={ onDependencySuccess } allData={ response } />
      ),
    };

    const dependencyRequests = {
      travelPolicy: getTravelPolicyDataReq,
      absentPolicy: getAbsentPolicyDataReq,
      lateArrivalPolicy: getLateArrivalPolicyDataReq,
      earlyLeftPolicy: getEarlyLeftPolicyDataReq,
      missingPolicy: getMissingPolicyDataReq,
      shortDurationPolicy: getShortDurationPolicyDataReq,
      relaxationPolicy: getRelaxationPolicyDataReq,
      leavePolicy: getLeavePolicyDataReq,
      cplPolicy: getCplPolicyDataReq,
      overtimePolicy: getOvertimePolicyDataReq,
    };

    openDependencyModal(dependencyFactories[dependencyKey], dependencyRequests[dependencyKey]);
  };

  // Create component modal
  const onCreate = () => {
    setChildComponent(
      <CreateRequestPolicyPlanner
        onCompleted={ onCompleted }
        allData={ allData }
        onSuccess={ onSuccess }
      />
    );
  };

  const onCompleted = (data) => {
    if (data.length) {
      setDataSource(data);
    }
    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);

  }

  //----end filter--------------------

  return (
    <>

      { childComponent }
      { props.embedded ? (
        <div>
          <div style={ { display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 12, flexWrap: "wrap" } }>
            <RefreshButton onClick={ getAllData } />
            <CreateButton onClick={ onCreate } />
            <FilterButton onClick={ onOpenFilter } />
          </div>
          <Row gutter={ [16, 16] } style={ { marginBottom: 16 } }>
            <Col xs={ 24 } lg={ 8 }>
              <Card
                title="Step 1. Setup Types"
                extra={ <Tag color="blue">Required for many policies</Tag> }
              >
                <Text type="secondary">
                  Create shared deduction and encashment types here so users do not need to leave this page before building policies.
                </Text>
                <Space wrap style={ { marginTop: 16 } }>
                  <Button type="primary" onClick={ () => onCreateDependency('deductionType') }>Create Deduction Type</Button>
                  <Button onClick={ () => onCreateDependency('encashmentType') }>Create Encashment Type</Button>
                </Space>
              </Card>
            </Col>
            <Col xs={ 24 } lg={ 8 }>
              <Card
                title="Step 2. Create Policies"
                extra={ <Tag color="gold">Inline setup</Tag> }
              >
                <Text type="secondary">
                  Add missing request-related policies from the same screen, then continue straight into the planner.
                </Text>
                <Space wrap style={ { marginTop: 16 } }>
                  <Button type="primary" onClick={ () => onCreateDependency('travelPolicy') }>Travel</Button>
                  <Button onClick={ () => onCreateDependency('absentPolicy') }>Absent</Button>
                  <Button onClick={ () => onCreateDependency('lateArrivalPolicy') }>Late Arrival</Button>
                  <Button onClick={ () => onCreateDependency('earlyLeftPolicy') }>Early Left</Button>
                  <Button onClick={ () => onCreateDependency('missingPolicy') }>Missing</Button>
                  <Button onClick={ () => onCreateDependency('shortDurationPolicy') }>Short Duration</Button>
                  <Button onClick={ () => onCreateDependency('relaxationPolicy') }>Relaxation</Button>
                  <Button onClick={ () => onCreateDependency('leavePolicy') }>Leave</Button>
                  <Button onClick={ () => onCreateDependency('overtimePolicy') }>Overtime</Button>
                  <Button onClick={ () => onCreateDependency('cplPolicy') }>CPL</Button>
                </Space>
              </Card>
            </Col>
            <Col xs={ 24 } lg={ 8 }>
              <Card
                title="Step 3. Build Planner"
                extra={ <Tag color="green">Final step</Tag> }
              >
                <Text type="secondary">
                  Once the required policies exist, create the request policy planner and assign it to employees without switching modules.
                </Text>
                <Space wrap style={ { marginTop: 16 } }>
                  <Button type="primary" onClick={ onCreate }>Create Planner</Button>
                  <Button onClick={ getAllData }>Refresh Planner List</Button>
                </Space>
              </Card>
            </Col>
          </Row>
          <TableComponent modkey={ props.modkey }
            loader={ loader }
            columns={ columns }
            dataSource={ dataSource }
            pagination={ { ...pagination, total: totalRecords } }
            onChange={ handleTableChange }
          />
          <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
        </div>
      ) : (
        <>
          <BodyComponent>
            <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
              <RefreshButton onClick={ getAllData } /> <CreateButton onClick={ onCreate } />
              <FilterButton onClick={ onOpenFilter } />
            </HeaderComponent>
            <Row gutter={ [16, 16] } style={ { marginBottom: 16 } }>
              <Col xs={ 24 } lg={ 8 }>
                <Card
                  title="Step 1. Setup Types"
                  extra={ <Tag color="blue">Required for many policies</Tag> }
                >
                  <Text type="secondary">
                    Create shared deduction and encashment types here so users do not need to leave this page before building policies.
                  </Text>
                  <Space wrap style={ { marginTop: 16 } }>
                    <Button type="primary" onClick={ () => onCreateDependency('deductionType') }>Create Deduction Type</Button>
                    <Button onClick={ () => onCreateDependency('encashmentType') }>Create Encashment Type</Button>
                  </Space>
                </Card>
              </Col>
              <Col xs={ 24 } lg={ 8 }>
                <Card
                  title="Step 2. Create Policies"
                  extra={ <Tag color="gold">Inline setup</Tag> }
                >
                  <Text type="secondary">
                    Add missing request-related policies from the same screen, then continue straight into the planner.
                  </Text>
                  <Space wrap style={ { marginTop: 16 } }>
                    <Button type="primary" onClick={ () => onCreateDependency('travelPolicy') }>Travel</Button>
                    <Button onClick={ () => onCreateDependency('absentPolicy') }>Absent</Button>
                    <Button onClick={ () => onCreateDependency('lateArrivalPolicy') }>Late Arrival</Button>
                    <Button onClick={ () => onCreateDependency('earlyLeftPolicy') }>Early Left</Button>
                    <Button onClick={ () => onCreateDependency('missingPolicy') }>Missing</Button>
                    <Button onClick={ () => onCreateDependency('shortDurationPolicy') }>Short Duration</Button>
                    <Button onClick={ () => onCreateDependency('relaxationPolicy') }>Relaxation</Button>
                    <Button onClick={ () => onCreateDependency('leavePolicy') }>Leave</Button>
                    <Button onClick={ () => onCreateDependency('overtimePolicy') }>Overtime</Button>
                    <Button onClick={ () => onCreateDependency('cplPolicy') }>CPL</Button>
                  </Space>
                </Card>
              </Col>
              <Col xs={ 24 } lg={ 8 }>
                <Card
                  title="Step 3. Build Planner"
                  extra={ <Tag color="green">Final step</Tag> }
                >
                  <Text type="secondary">
                    Once the required policies exist, create the request policy planner and assign it to employees without switching modules.
                  </Text>
                  <Space wrap style={ { marginTop: 16 } }>
                    <Button type="primary" onClick={ onCreate }>Create Planner</Button>
                    <Button onClick={ getAllData }>Refresh Planner List</Button>
                  </Space>
                </Card>
              </Col>
            </Row>
            <TableComponent modkey={ props.modkey }
              loader={ loader }
              columns={ columns }
              dataSource={ dataSource }
              pagination={ { ...pagination, total: totalRecords } }
              onChange={ handleTableChange }
            />
          </BodyComponent>
          <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
        </>
      ) }
    </>
  );
};

export default IndexRequestPolicyPlanner;
const filterFields = [
  {
    type: "text",
    placeholder: "Code",
    key: "code"
  },
  {
    type: "text",
    placeholder: "Name",
    key: "name"
  },
  {
    type: "date",
    placeholder: "From",
    key: "from"
  },
  {
    type: "date",
    placeholder: "To",
    key: "to"
  },
]
